import Vue from 'vue'
import VueRouter from 'vue-router'
import { handleLocalStorage } from '@/utils/handleLocalStorage.js'
import asyncRoutes from './permission'
import store from '@/store'

Vue.use(VueRouter)
const ModelView = () => import('views/ModelView')
// 登录页
const Entrance = () => import('views/Entrance/index.vue')
const Protocol = () => import('views/Entrance/Protocol.vue')


// 官网
const PageIndex = () => import('views/Website/index.vue')
const PageHome = () => import('views/Website/PageHome.vue')
const PageCase = () => import('views/Website/PageCase.vue')
const OuterChain = () => import('views/Website/outerChain.vue')

// 我的模型
const UserModel = () => import('views/UserModel.vue')
// 手机端进阶体验
const AdvancedMobile = () => import('views/new/home/user/index/home_management/advancedMobile.vue')
// pc进阶体验
const AdvancedList = () => import('views/new/home/user/index/home_management/advancedList.vue')

// ieds简介
const IedsInfo = () => import('views/IedsInfo.vue')


// 模型编辑
const Editor = () => import('views/new/editor/Editor')
const SetOverview = () => import('views/new/editor/set_overview/SetOverview')
const ViewLoad = () => import('views/new/editor/view_load/ViewLoad')
const SpaceEnter = () => import('views/new/editor/space_enter/SpaceEnter')
const MenuView = () => import('views/new/editor/menu_view/MenuView')
const ViewRoam = () => import('views/new/editor/view_roam/ViewRoam')
const ViewGod = () => import('views/new/editor/view_god/ViewGod')
const FunctionHotpoint = () => import('views/new/editor/function_hotpoint/FunctionHotpoint')
// 通知页
const NotificationPage = () => import('@/components/new/home/NotificationPage.vue')

let routes = []
if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_CURRENTMODE === 'simple') {
  routes = [
    {
      path: '/play',
      name: 'ModelView',
      component: ModelView,
      meta: { title: '线上展馆' }
    }
  ]
} else {
  routes = [
    {
      path: '/',
      name: 'Website',
      meta: { title: '川云引擎｜VR云展馆平台' },
      component: PageIndex,
      redirect: { name: 'PageHome' },
      children: [
        {
          path: '/',
          name: 'PageHome',
          component: PageHome,
          meta: { title: '川云引擎｜VR云展馆平台-首页' }
        },
        {
          path: '/case',
          name: 'PageCase',
          component: PageCase,
          meta: { title: '川云引擎｜VR云展馆平台-案例' }
        },
      ]
    },
    {
      path: '/login',
      name: 'Entrance',
      component: Entrance,
      meta: { title: '川云引擎｜VR云展馆平台-登录页' }
    },
    {
      path: '/outer',
      name: 'OuterChain',
      component: OuterChain,
      meta: { title: '川云引擎｜VR云展馆平台' }
    },
    
    {
      path: '/usermodel',
      name: 'UserModel',
      component: UserModel,
      meta: { title: '我的模型' }
    },
    {
      path: '/advancedmobile',
      name: 'AdvancedMobile',
      component: AdvancedMobile,
      meta: { title: '进阶体验' }
    },
    {
      path: '/advancedList',
      name: 'AdvancedList',
      component: AdvancedList,
      meta: { title: '进阶体验' }
    },

    
    
    {
      path: '/iedsinfo',
      name: 'IedsInfo',
      component: IedsInfo,
      meta: { title: 'IEDS简介' }
    },
    
    {
      path: '/protocol',
      name: 'Protocol',
      component: Protocol,
      meta: { title: '川云引擎｜VR云展馆平台-协议' }
    },
    {
      path: '/editor',
      name: 'editor',
      component: Editor,
      redirect: '/editor/set_overview',
      children: [
        {
          path: '/editor/set_overview',
          name: 'setOverview',
          component: SetOverview,
          meta: { title: '川云引擎｜VR云展馆平台-模型设置' }
        },
        {
          path: '/editor/view_load',
          name: 'viewLoad',
          component: ViewLoad,
          meta: { title: '川云引擎｜VR云展馆平台-界面加载' }
        },
        {
          path: '/editor/space_enter',
          name: 'spaceEnter',
          component: SpaceEnter,
          meta: { title: '川云引擎｜VR云展馆平台-进入空间' }
        },
        {
          path: '/editor/menu_view',
          name: 'menuView',
          component: MenuView,
          meta: { title: '川云引擎｜VR云展馆平台-界面菜单' }
        },
        {
          path: '/editor/view_roam',
          name: 'viewRoam',
          component: ViewRoam,
          meta: { title: '川云引擎｜VR云展馆平台-漫游界面' }
        },
        {
          path: '/editor/view_god',
          name: 'viewGod',
          component: ViewGod,
          meta: { title: '川云引擎｜VR云展馆平台-上帝视角' }
        },
        {
          path: '/editor/function_hotpoint',
          name: 'functionHotpoint',
          component: FunctionHotpoint,
          meta: { title: '川云引擎｜VR云展馆平台-热点功能' }
        }
      ]
    },
    {
      path: '/play',
      name: 'modelView',
      component: ModelView,
      meta: { title: '线上展馆' }
    },
    {
      path: '/notification_page',
      name: 'NotificationPage',
      component: NotificationPage,
      meta: { title: '川云引擎｜VR云展馆平台-通知页' }
    }
  ]
}


// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push (location, onResolve, onReject) {
//   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//   return originalPush.call(this, location).catch(err => err)
// }

// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_ACCESS_URL : '/',
//   routes
// });

const createRouter = () => new VueRouter({
  mode: 'history',
  // base: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_ACCESS_URL : '/',
  base: process.env.VUE_APP_ACCESS_URL,
  routes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // 重置路由
}

// 白名单
const whiteRoutePath = ['/', '/login', '/protocol']

router.beforeEach((to, from, next) => {
  // 不是预览页
  if (to.path !== '/play') {
    // 判断是否是登录状态
    if (handleLocalStorage.getTokenItem()) {
      // 如果没有路由缓存，则请求重新添加
      let permissionList = store.state.permission.permissionList
      if (permissionList.length) {
        // 如果访问登录页，则跳转到官网首页
        if(to.path === '/login') next('/')
        else next()
      } else {
        // 调用接口获取权限列表
        store.dispatch('permission/getPermissionList', asyncRoutes).then(res => {
          router.addRoutes(res)
          next({
            ...to, // next({ ...to })的目的,是保证路由添加完了再进入页面 (可以理解为重进一次)
            replace: true, // 重进一次, 不保留重复历史
          })
        })
      }
    } else {
      if(whiteRoutePath.includes(to.path)) {
        next()
      } else {
        // next('/')
      }
    }
  }
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
